module.exports = __webpack_public_path__ + "static/media/rule_btn.186003ea.png";